const SkeletonCardUpcoming = () => {
    return (
        <div className="ml-4 flex mb-3">
        <div className="w-[120px] h-[190px] bg-white rounded-lg animate-pulse"></div>
        <div className="px-3">
            <div className="w-[120px] h-[15px] mb-3 bg-white animate-pulse rounded-full"></div>
            <div className="w-[100px] h-[15px] bg-white animate-pulse rounded-full"></div>
        </div>
        </div>
    )
}

export default SkeletonCardUpcoming